import axios from 'axios';

export const httpModules = axios.create({
	baseURL: '',
});
